// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3EtXo","notes":"Notes_notes__33A-X","note":"Notes_note__1-nc-","markdown":"Notes_markdown__27vTV"};